/** Approved tracking-sheet event names (Mixpanel + CleverTap). */
export const GAME_ANALYTICS_EVENTS = {
  USER_PLAYED_GAME: "User_Played_Game",
  GAME_CHALLENGE_ISSUED: "Game Challenge Issued",
  GAME_CHALLENGE_COMPLETED: "Game Challenge Completed",
  GAME_PAGE_CLICK: "Game Page Click",
} as const;

/** Approved tracking-sheet attribute keys. */
export const GAME_ANALYTICS_ATTRIBUTES = {
  GAME_CHALLENGE_ID: "Game Challenge ID",
  GAME_CHALLENGE_CATEGORY: "Game Challenge Category",
  GAME_CHALLENGE_TIME_LIMIT: "Game Challenge Time Limit",
  GAME_CHALLENGE_NAME: "Game Challenge Name",
  GAME_CHALLENGE_TYPE: "Game Challenge Type",
  GAME_CHALLENGE_PRIZE_VALUE: "Game Challenge Prize Value",
  GAME_CHALLENGE_PRIZE_TYPE: "Game Challenge Prize Type",
  GAME_CHALLENGE_LEVEL_GOAL: "Game Challenge Level Goal",
  GAME_CHALLENGE_DIFFICULTY: "Game Challenge Difficulty",
  GAME_CHALLENGE_TIMESTAMP_ISSUED: "Game Challenge Timestamp Issued",
  GAME_CHALLENGE_TIMESTAMP_COMPLETE: "Game Challenge Timestamp Complete",
  GAME_CHALLENGE_LEVEL_RESULT: "Game Challenge Level Result",
  GAME_CHALLENGE_OUTCOME: "Game Challenge Outcome",
  GAME_PAGE_CLICK_OBJECT: "Game Page Click Object",
  GAME_PAGE_CLICK_ELEMENT: "Game Page Click Element",
} as const;

export type GameChallengeOutcome =
  | "Won"
  | "Lost"
  | "Incomplete"
  | "Expired"
  | "Not Started";

export type GamePageClickInput = {
  object: string;
  element: string;
};
